import {
  MODIFY_PICTURES,
  LISTING_MODIFICATION,
  UNPUBLISH_REQUEST,
  ACTIVATE_INSTANT_BOOKING,
  BOOKING_STATUS,
  TENANT_COMPLAINT,
  LANDLORD_DATES_MODIFICATION,
  LANDLORD_BC_CANCELLATION,
  PAYMENT_MISSING,
  CLAIM_GUARANTEE,
  LL_PANEL_ACCESS,
  LL_PANEL_BUG,
  LL_PANEL_DOUBTS,
  COMMERCIAL_ADVICE,
  LANDLORD_ACCOUNT_ACCESS,
  LANDLORD_CHANGE_CONTACT_DETAILS,
  LANDLORD_DELETE_ACCOUNT,
  PUBLISH_PROPERTIES
} from './landlordReasons';

const NOT_SPOTAHOME_CATEGORY = 'not_spotahome';
const SPOTAHOME_CATEGORY = 'spotahome';

export const LANDLORD_CATEGORY_IDS = [
  NOT_SPOTAHOME_CATEGORY,
  SPOTAHOME_CATEGORY
];

const LISTING = 'listing';
const BOOKING = 'booking';
const LANDLORD_PANEL = 'landlord_panel';
const PERFORMANCE = 'performance';
const ACCOUNT = 'account';
const NOT_SPOTAHOME = 'not_spotahome';

export const LANDLORD_SECTION_IDS = [
  LISTING,
  BOOKING,
  LANDLORD_PANEL,
  PERFORMANCE,
  ACCOUNT,
  NOT_SPOTAHOME
];

export const LANDLORD_CONFIG = {
  [SPOTAHOME_CATEGORY]: {
    [LISTING]: [
      MODIFY_PICTURES,
      LISTING_MODIFICATION,
      UNPUBLISH_REQUEST,
      ACTIVATE_INSTANT_BOOKING
    ],
    [BOOKING]: [
      BOOKING_STATUS,
      TENANT_COMPLAINT,
      LANDLORD_DATES_MODIFICATION,
      LANDLORD_BC_CANCELLATION,
      PAYMENT_MISSING,
      CLAIM_GUARANTEE
    ],
    [LANDLORD_PANEL]: [LL_PANEL_ACCESS, LL_PANEL_BUG, LL_PANEL_DOUBTS],
    [PERFORMANCE]: [COMMERCIAL_ADVICE],
    [ACCOUNT]: [
      LANDLORD_ACCOUNT_ACCESS,
      LANDLORD_CHANGE_CONTACT_DETAILS,
      LANDLORD_DELETE_ACCOUNT
    ]
  },
  [NOT_SPOTAHOME_CATEGORY]: {
    [NOT_SPOTAHOME]: [PUBLISH_PROPERTIES]
  }
};
